export class PresentationManager {
  constructor() {
    const introSlide = document.querySelector('.intro.slide');
    const firstContentSlide = introSlide?.nextElementSibling as HTMLElement | null;

    if (introSlide && firstContentSlide) {
      firstContentSlide.setAttribute('id', 'first-content-slide');

      // Intercept click on scroll down button
      const scrollDownBtn = introSlide.querySelector('.wp-block-button__link') as HTMLAnchorElement;

      scrollDownBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        firstContentSlide.scrollIntoView({ behavior: 'smooth' });
      });
    }

    const endSlide = document.querySelector('.end.slide') as HTMLElement | null;

    if (endSlide) {
      // const seeMoreWorkBtn = endSlide.querySelector('.wp-block-button__link') as HTMLAnchorElement;
      // seeMoreWorkBtn.parentElement?.classList.add('anim-u', 'text-blue');
      // seeMoreWorkBtn.querySelector('strong')!.classList.add('anim-u-target', 'from-current', 'to-current');

      const emailPattern = new RegExp(`([a-zA-Z0-9._%+-]+)@suburbia-media.com`);
      const paragraphs = endSlide.querySelectorAll('strong');

      console.log(paragraphs);

      paragraphs.forEach((p) => {
        const match = p.textContent?.match(emailPattern);

        if (match) {
          const email = match[0];
          const emailLink = document.createElement('a');
          emailLink.classList.add("anim-u-target", "from-current", "to-current");
          emailLink.href = `mailto:${email}`;
          emailLink.textContent = email;

          p.textContent = p.textContent!.replace(email, '');
          p.appendChild(emailLink);
          p.classList.add('anim-u', 'text-blue');
        }
      });
    }
  }
}
